import {
    faBold,
    faIndent,
    faItalic,
    faListOl,
    faListUl,
    faOutdent,
    faStrikethrough,
    faUnderline,
} from "@fortawesome/free-solid-svg-icons";
import { BlockStyle, FormattingTool } from "./types";

export const textTools: FormattingTool[] = [
    { ariaLabel: "Bold", icon: faBold, command: "bold" },
    { ariaLabel: "Italic", icon: faItalic, command: "italic" },
    { ariaLabel: "Underline", icon: faUnderline, command: "underline" },
    { ariaLabel: "Strikethrough", icon: faStrikethrough, command: "strikeThrough" },
];

export const listTools: FormattingTool[] = [
    { ariaLabel: "Bulleted list", icon: faListUl, command: "insertUnorderedList" },
    { ariaLabel: "Numbered list", icon: faListOl, command: "insertOrderedList" },
];

export const indentTools: FormattingTool[] = [
    { ariaLabel: "Decrease indent", icon: faOutdent, command: "outdent" },
    { ariaLabel: "Increase indent", icon: faIndent, command: "indent" },
];

export const blockStyles: Array<{ label: string; value: BlockStyle }> = [
    { label: "Body", value: "div" },
    { label: "Heading", value: "h2" },
    { label: "Subheading", value: "h3" },
];
